import TextareaAutosize from 'react-textarea-autosize';
import cx from 'classnames';

import './FormTextArea.scss';

export const FormTextArea = ({
  className,
  name,
  value,
  disabled,
  title,
  onChange,
  minRows = 5,
  maxRows = 5,
}) => {
  const handleChange = e => {
    name ? onChange(name, e.target.value) : onChange(e.target.value);
  };

  return (
    <div className={cx('form-textarea__container', { disabled })}>
      {!!value && value.length !== 0 && <div className="form-textarea__title">{title}</div>}
      <TextareaAutosize
        minRows={minRows}
        maxRows={maxRows}
        className={cx('form-textarea', className)}
        name={name}
        placeholder={title}
        value={value}
        onChange={e => handleChange(e)}
      />
    </div>
  );
};
